<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="approval-main">
      <el-collapse v-model="collapseActiveName" accordion>

        <el-collapse-item name="1">
          <template slot="title">
            <el-badge :value="pendingApprovalTotal" class="item"><i class="el-icon-damai-hetong"></i>合同审批</el-badge>
          </template>
          <div class="approval-main-top">
            <el-tabs v-model="activeName">
              <el-tab-pane label="待我审批" name="pendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="pendingApprovalTableHead" :tableData="pendingApprovalTableData" :operationArr="pendingApprovalOperationArr" @toDetailsPage="toDetailsPage" :total="pendingApprovalTotal" :pageNum="pendingApprovalPageNum" :pageSize="pendingApprovalPageSize" :row-click="toDetailsPage" @changePagination="changePendingApprovalPagination" />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="approved">
                <table-main :tableHeight="520" :selection="false" :tableHead="approvedTableHead" :tableData="approvedTableData" :operationArr="approvedOperationArr" @toDetailsPage="toDetailsPage" :row-click="toDetailsPage" :total="approvedTotal" :pageNum="approvedPageNum" :pageSize="approvedPageSize" @changePagination="changeApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="sponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="sponsoredTableHead" :tableData="sponsoredTableData" :operationArr="sponsoredOperationArr" @toDetailsPage="toDetailsPage" :row-click="toDetailsPage" :total="sponsoredTotal" :pageNum="sponsoredPageNum" :pageSize="sponsoredPageSize" @changePagination="changeSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-collapse-item>
        <el-collapse-item :title="electricCollapseItemTitle" name="2">
          <template slot="title">
            <el-badge :value="electricPendingApprovalTotal" class="item"><i class="el-icon-damai-dian"></i>电费充值审批</el-badge>
          </template>
          <div class="approval-main-bottom">
            <el-tabs v-model="electricActiveName">
              <el-tab-pane label="待我审批" name="electricPendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="electricPendingApprovalTableHead" :tableData="electricPendingApprovalTableData" :operationArr="electricPendingApprovalOperationArr" @electricApproveRow="electricApproveRow" @electricUnApproveRow="electricUnApproveRow" :total="electricPendingApprovalTotal" :pageNum="electricPendingApprovalPageNum" :pageSize="electricPendingApprovalPageSize" @changePagination="changeElectricPendingApprovalPagination"  />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="electricApproved">
                <table-main :tableHeight="520" :selection="false" :tableHead="electricApprovedTableHead" :tableData="electricApprovedTableData" :operationArr="electricApprovedOperationArr" @toDetailsPage="toDetailsPage" :total="electricApprovedTotal" :pageNum="electricApprovedPageNum" :pageSize="electricApprovedPageSize" :hasOperation="false" @changePagination="changeElectricApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="electricSponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="electricSponsoredTableHead" :tableData="electricSponsoredTableData" :operationArr="electricSponsoredOperationArr" @toDetailsPage="toDetailsPage" :total="electricSponsoredTotal" :pageNum="electricSponsoredPageNum" :pageSize="electricSponsoredPageSize" :hasOperation="false" @changePagination="changeElectricSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-collapse-item>
        <el-collapse-item :title="waterCollapseItemTitle" name="5">
          <template slot="title">
            <el-badge :value="waterPendingApprovalTotal" class="item"><i class="el-icon-damai-shui" style="font-size: 22px;"></i>水费充值审批</el-badge>
          </template>
          <div class="approval-main-bottom">
            <el-tabs v-model="waterActiveName">
              <el-tab-pane label="待我审批" name="waterPendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="waterPendingApprovalTableHead" :tableData="waterPendingApprovalTableData" :operationArr="waterPendingApprovalOperationArr" @electricApproveRow="waterApproveRow" @electricUnApproveRow="waterUnApproveRow" :total="waterPendingApprovalTotal" :pageNum="waterPendingApprovalPageNum" :pageSize="waterPendingApprovalPageSize" @changePagination="changeWaterPendingApprovalPagination"  />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="waterApproved">
                <table-main :tableHeight="520" :selection="false" :tableHead="waterApprovedTableHead" :tableData="waterApprovedTableData" :operationArr="waterApprovedOperationArr" @toDetailsPage="toDetailsPage" :total="waterApprovedTotal" :pageNum="waterApprovedPageNum" :pageSize="waterApprovedPageSize" :hasOperation="false" @changePagination="changeWaterApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="waterSponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="waterSponsoredTableHead" :tableData="waterSponsoredTableData" :operationArr="waterSponsoredOperationArr" @toDetailsPage="toDetailsPage" :total="waterSponsoredTotal" :pageNum="waterSponsoredPageNum" :pageSize="waterSponsoredPageSize" :hasOperation="false" @changePagination="changeWaterSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <el-badge :value="billPendingApprovalTotal" class="item"><i class="el-icon-damai-zhangdan1"></i>账单修改审批</el-badge>
          </template>
          <div class="approval-main-bottom">
            <el-tabs v-model="billActiveName">
              <el-tab-pane label="待我审批" name="billPendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="billPendingApprovalTableHead" :tableData="billPendingApprovalTableData" :operationArr="billPendingApprovalOperationArr" @electricApproveRow="billApproveRow" @electricUnApproveRow="billUnApproveRow" :total="billPendingApprovalTotal" :pageNum="billPendingApprovalPageNum" :pageSize="billPendingApprovalPageSize" @changePagination="changeBillPendingApprovalPagination"  />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="billApproved">
                <table-main :tableHeight="520" :selection="false" :tableHead="billApprovedTableHead" :tableData="billApprovedTableData" :operationArr="billApprovedOperationArr" @toDetailsPage="toDetailsPage" :total="billApprovedTotal" :pageNum="billApprovedPageNum" :pageSize="billApprovedPageSize" :hasOperation="false" @changePagination="changeBillApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="billSponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="billSponsoredTableHead" :tableData="billSponsoredTableData" :operationArr="billSponsoredOperationArr" @toDetailsPage="toDetailsPage" :total="billSponsoredTotal" :pageNum="billSponsoredPageNum" :pageSize="billSponsoredPageSize" :hasOperation="false" @changePagination="changeBillSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <el-badge :value="total" class="item"><i class="el-icon-damai-tousu"></i>投诉建议</el-badge>
          </template>
          <div class="approval-main-bottom">
            <table-main :selection=false :tableHead="tableHead" :operationArr="operationArr" :tableData="tableData" @goToModifyPage="goToModifyPage" :total="total" :pageNum="pageNum" :pageSize="pageSize" />
          </div>
        </el-collapse-item>
        <el-collapse-item :title="hatchCollapseItemTitle" name="6">
          <template slot="title">
            <el-badge :value="hatchPendingApprovalTotal" class="item"><i class="el-icon-damai-kejiqiyefuhuaqijienadaxueshengkejiqiyebutie" style="font-size: 22px;"></i>孵化审批</el-badge>
          </template>
          <div class="approval-main-bottom">
            <el-tabs v-model="hatchActiveName">
              <el-tab-pane label="待我审批" name="hatchPendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="hatchPendingApprovalTableHead" :tableData="hatchPendingApprovalTableData" :operationArr="hatchPendingApprovalOperationArr" @toDetailsPage="toHatchDetailsPage" :total="hatchPendingApprovalTotal" :pageNum="hatchPendingApprovalPageNum" :pageSize="hatchPendingApprovalPageSize" :row-click="toHatchDetailsPage" @changePagination="changeHatchPendingApprovalPagination" />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="hatchApproved">
                <table-main :tableHeight="520" :selection="false" :tableHead="hatchApprovedTableHead" :tableData="hatchApprovedTableData" :operationArr="hatchApprovedOperationArr" @toDetailsPage="toHatchDetailsPage" :row-click="toHatchDetailsPage" :total="hatchApprovedTotal" :pageNum="hatchApprovedPageNum" :pageSize="hatchApprovedPageSize" @changePagination="changeHatchApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="hatchSponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="hatchSponsoredTableHead" :tableData="hatchSponsoredTableData" :operationArr="hatchSponsoredOperationArr" @toDetailsPage="toHatchDetailsPage" :row-click="toHatchDetailsPage" :total="hatchSponsoredTotal" :pageNum="hatchSponsoredPageNum" :pageSize="hatchSponsoredPageSize" @changePagination="changeHatchSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-collapse-item>
        <el-collapse-item :title="attendanceItemTitle" name="7">
          <template slot="title">
            <el-badge :value="attendancePendingApprovalTotal" class="item"><i class="el-icon-damai-sign"></i>考勤审批</el-badge>
          </template>
          <div class="approval-main-bottom">
            <el-tabs v-model="attendanceActiveName">
              <el-tab-pane label="待我审批" name="attendancePendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="attendancePendingApprovalTableHead" :tableData="attendancePendingApprovalTableData" :operationArr="attendancePendingApprovalOperationArr" @electricApproveRow="attendanceApproveRow" @electricUnApproveRow="attendanceUnApproveRow" :total="attendancePendingApprovalTotal" :pageNum="attendancePendingApprovalPageNum" :pageSize="attendancePendingApprovalPageSize" @changePagination="changeAttendancePendingApprovalPagination"  />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="attendanceApproved">
                <table-main :tableHeight="520" :selection="false" :tableHead="attendanceApprovedTableHead" :tableData="attendanceApprovedTableData" :operationArr="attendanceApprovedOperationArr" :total="attendanceApprovedTotal" :pageNum="attendanceApprovedPageNum" :pageSize="attendanceApprovedPageSize" :hasOperation="false" @changePagination="changeAttendanceApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="attendanceSponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="attendanceSponsoredTableHead" :tableData="attendanceSponsoredTableData" :operationArr="attendanceSponsoredOperationArr" :total="attendanceSponsoredTotal" :pageNum="attendanceSponsoredPageNum" :pageSize="attendanceSponsoredPageSize" :hasOperation="false" @changePagination="changeAttendanceSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="approveMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="passSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="approveRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="rejectMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelReject">取 消</el-button>
          <el-button size="small" type="primary" @click="unpassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--水费-->
    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="waterApproveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="waterApproveMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="waterCancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="waterPassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="waterApproveRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="waterRejectMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="waterCancelReject">取 消</el-button>
          <el-button size="small" type="primary" @click="waterUnpassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--账单修改通过-->
    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="approveBillDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="billMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelBillApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="passBillSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--账单修改驳回-->
    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="approveBillRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="billMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelBillReject">取 消</el-button>
          <el-button size="small" type="primary" @click="unpassBillSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--考勤审批通过-->
    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="approveAttendanceDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="attendanceMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelAttendanceApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="passAttendanceSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--考勤审批驳回-->
    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="approveAttendanceRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="attendanceMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelAttendanceReject">取 消</el-button>
          <el-button size="small" type="primary" @click="unpassAttendanceSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { api } from "../api/WorkbenchApproval";
import TableMain from "../../components/Table/TableMain";
import { errorHandler } from "../../utils/errorHandler";
import { bus } from "../../utils/bus";
import { nSuccess } from "../../utils/notice";

export default {
  components: {
    TableMain,
    Breadcrumb,
  },
  name: "workbench-approval",
  data() {
    return {
      yqCode: "",
      breadcrumb: [
        {
          value: "工作台",
          name: "workbench",
        },
        {
          value: "审批列表",
        },
      ],
      collapseActiveName: "",
      contractCollapseItemTitle: "合同审批",
      electricCollapseItemTitle: "电费充值审批",
      waterCollapseItemTitle: "水费充值审批",
      billCollapseItemTitle: "账单修改审批",
      hatchCollapseItemTitle: "孵化审批",
      attendanceItemTitle: "考勤审批",
      accountCode: "",
      activeName: "pendingApproval",
      electricActiveName: "electricPendingApproval",
      waterActiveName: "waterPendingApproval",
      billActiveName: "billPendingApproval",
      hatchActiveName: "hatchPendingApproval",
      attendanceActiveName: "attendancePendingApproval",

      // 我发起的
      sponsoredTableHead: [
        {
          prop: "auditType",
          label: "审核类型",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "handlePeople",
          label: "处理人",
        },
      ],
      sponsoredTableData: [],
      sponsoredOperationArr: ["details"],
      sponsoredTotal: 0,
      sponsoredPageNum: 1,
      sponsoredPageSize: 10,

      // 待我审批
      pendingApprovalTableHead: [
        {
          prop: "auditType",
          label: "审核类型",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
      ],
      pendingApprovalTableData: [],
      pendingApprovalOperationArr: ["details"],
      pendingApprovalTotal: 0,
      pendingApprovalPageNum: 1,
      pendingApprovalPageSize: 10,

      // 我已审批
      approvedTableHead: [
        {
          prop: "auditType",
          label: "审核类型",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
      ],
      approvedTableData: [],
      approvedOperationArr: ["details"],
      approvedTotal: 0,
      approvedPageNum: 1,
      approvedPageSize: 10,

      // 我发起的(电费)
      electricSponsoredTableHead: [
        {
          prop: "indexProgress",
          label: "审批进度",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
        {
          prop: "approveAccountName",
          label: "处理人",
        },
      ],
      electricSponsoredTableData: [],
      electricSponsoredOperationArr: ["details"],
      electricSponsoredTotal: 0,
      electricSponsoredPageNum: 1,
      electricSponsoredPageSize: 10,

      // 待我审批(电费)
      electricPendingApprovalTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
      ],
      electricPendingApprovalTableData: [],
      electricPendingApprovalOperationArr: [
        "electricApproveRow",
        "electricUnApproveRow",
      ],
      electricPendingApprovalTotal: 0,
      electricPendingApprovalPageNum: 1,
      electricPendingApprovalPageSize: 10,

      // 我已审批(电费)
      electricApprovedTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "approveDate",
          label: "审批时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
      ],
      electricApprovedTableData: [],
      electricApprovedOperationArr: ["details"],
      electricApprovedTotal: 0,
      electricApprovedPageNum: 1,
      electricApprovedPageSize: 10,

      // 我发起的(水费)
      waterSponsoredTableHead: [
        {
          prop: "indexProgress",
          label: "审批进度",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
        {
          prop: "approveAccountName",
          label: "处理人",
        },
      ],
      waterSponsoredTableData: [],
      waterSponsoredOperationArr: ["details"],
      waterSponsoredTotal: 0,
      waterSponsoredPageNum: 1,
      waterSponsoredPageSize: 10,

      // 待我审批(水费)
      waterPendingApprovalTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
      ],
      waterPendingApprovalTableData: [],
      waterPendingApprovalOperationArr: [
        "electricApproveRow",
        "electricUnApproveRow",
      ],
      waterPendingApprovalTotal: 0,
      waterPendingApprovalPageNum: 1,
      waterPendingApprovalPageSize: 10,

      // 我已审批(水费)
      waterApprovedTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "approveDate",
          label: "审批时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
      ],
      waterApprovedTableData: [],
      waterApprovedOperationArr: ["details"],
      waterApprovedTotal: 0,
      waterApprovedPageNum: 1,
      waterApprovedPageSize: 10,

      electricApproveData: {},
      electricUnApproveData: {},
      approveDialog: false,
      approveMemo: "",
      approveRejectDialog: false,
      rejectMemo: "",

      waterApproveData: {},
      waterUnApproveData: {},
      waterApproveDialog: false,
      waterApproveMemo: "",
      waterApproveRejectDialog: false,
      waterRejectMemo: "",

      billApproveData: {},
      billUnApproveData: {},
      approveBillDialog: false,
      approveBillRejectDialog: false,
      billMemo: "",

      // 我发起的(账单)
      billSponsoredTableHead: [
        {
          prop: "indexProgress",
          label: "审批进度",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
        {
          prop: "approveAccountName",
          label: "处理人",
        },
      ],
      billSponsoredTableData: [],
      billSponsoredOperationArr: ["details"],
      billSponsoredTotal: 0,
      billSponsoredPageNum: 1,
      billSponsoredPageSize: 10,

      // 待我审批(账单)
      billPendingApprovalTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
      ],
      billPendingApprovalTableData: [],
      billPendingApprovalOperationArr: [
        "electricApproveRow",
        "electricUnApproveRow",
      ],
      billPendingApprovalTotal: 0,
      billPendingApprovalPageNum: 1,
      billPendingApprovalPageSize: 10,

      // 我已审批(账单)
      billApprovedTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "approveDate",
          label: "审批时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
      ],
      billApprovedTableData: [],
      billApprovedOperationArr: ["details"],
      billApprovedTotal: 0,
      billApprovedPageNum: 1,
      billApprovedPageSize: 10,

      // 投诉建议
      tableHead: [
        {
          prop: "personName",
          label: "人员姓名",
        },
        {
          prop: "personPhone",
          label: "手机号",
        },
        {
          prop: "roomNumber",
          label: "房间号",
        },
        {
          prop: "enterpriseName",
          label: "住户名称",
        },
        {
          prop: "type",
          label: "类型",
        },
        {
          prop: "createTime",
          label: "提交时间",
        },
        {
          prop: "statusText",
          label: "状态",
        },
      ],
      operationArr: ["modifySuggestions"],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        responsiblePersonCode: "",
        searchKey: "",
        result: "",
        status: "0",
      },

      // 我发起的(孵化)
      hatchSponsoredTableHead: [
        {
          prop: "auditType",
          label: "审核类型",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "handlePeople",
          label: "处理人",
        },
      ],
      hatchSponsoredTableData: [],
      hatchSponsoredOperationArr: ["details"],
      hatchSponsoredTotal: 0,
      hatchSponsoredPageNum: 1,
      hatchSponsoredPageSize: 10,

      // 待我审批(孵化)
      hatchPendingApprovalTableHead: [
        {
          prop: "auditType",
          label: "审核类型",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
      ],
      hatchPendingApprovalTableData: [],
      hatchPendingApprovalOperationArr: ["details"],
      hatchPendingApprovalTotal: 0,
      hatchPendingApprovalPageNum: 1,
      hatchPendingApprovalPageSize: 10,

      // 我已审批(孵化)
      hatchApprovedTableHead: [
        {
          prop: "auditType",
          label: "审核类型",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
      ],
      hatchApprovedTableData: [],
      hatchApprovedOperationArr: ["details"],
      hatchApprovedTotal: 0,
      hatchApprovedPageNum: 1,
      hatchApprovedPageSize: 10,

      attendanceApproveData: {},
      attendanceUnApproveData: {},
      approveAttendanceDialog: false,
      approveAttendanceRejectDialog: false,
      attendanceMemo: "",

      // 我发起的(考勤)
      attendanceSponsoredTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
        {
          prop: "approveAccountName",
          label: "处理人",
        },
      ],
      attendanceSponsoredTableData: [],
      attendanceSponsoredOperationArr: ["details"],
      attendanceSponsoredTotal: 0,
      attendanceSponsoredPageNum: 1,
      attendanceSponsoredPageSize: 10,

      // 待我审批(考勤)
      attendancePendingApprovalTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
      ],
      attendancePendingApprovalTableData: [],
      attendancePendingApprovalOperationArr: [
        "electricApproveRow",
        "electricUnApproveRow",
      ],
      attendancePendingApprovalTotal: 0,
      attendancePendingApprovalPageNum: 1,
      attendancePendingApprovalPageSize: 10,

      // 我已审批(考勤)
      attendanceApprovedTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "approveDate",
          label: "审批时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
      ],
      attendanceApprovedTableData: [],
      attendanceApprovedOperationArr: ["details"],
      attendanceApprovedTotal: 0,
      attendanceApprovedPageNum: 1,
      attendanceApprovedPageSize: 10,
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.requestData.responsiblePersonCode = bus.global.accountCode;
    this.accountCode = bus.global.accountCode;
    this.getPendingApprovalPage();
    this.getPageByElectricPendingApprovalPage();
    this.getPageByWaterPendingApprovalPage();
    this.getPageByBillPendingApprovalPage();
    this.getPageByHatchPendingApprovalPage();
    this.getPage();
    this.getPageByAttendancePendingApprovalPage();
  },
  mounted() {
    if (this.$route.params.workType) {
      this.activeName = this.$route.params.workType;
    }
  },
  methods: {
    // 跳转审批详情页面
    toDetailsPage(data) {
      sessionStorage.setItem("workDetailData", JSON.stringify(data));
      sessionStorage.setItem("workDetailActiveName", this.activeName);
      if (data.type === "其他合同") {
        this.$router.push({
          name: "other-approval-detail",
        });
      } else {
        this.$router.push({
          name: "approval-detail",
        });
      }
    },

    // 我发起的页码跳转
    changeSponsoredPagination(data) {
      this.sponsoredPageNum = data[0];
      this.sponsoredPageSize = data[1];
      this.getPageBySponsorAccountCode();
    },

    // 待我审批页码跳转
    changePendingApprovalPagination(data) {
      this.pendingApprovalPageNum = data[0];
      this.pendingApprovalPageSize = data[1];
      this.getPendingApprovalPage();
    },

    // 我已审批页码跳转
    changeApprovedPagination(data) {
      this.approvedPageNum = data[0];
      this.approvedPageSize = data[1];
      this.getApprovedPage();
    },

    // 我发起的页码跳转(电费)
    changeElectricSponsoredPagination(data) {
      this.electricSponsoredPageNum = data[0];
      this.electricSponsoredPageSize = data[1];
      this.getPageByElectricSponsorAccountCode();
    },

    // 待我审批页码跳转(电费)
    changeElectricPendingApprovalPagination(data) {
      this.electricPendingApprovalPageNum = data[0];
      this.electricPendingApprovalPageSize = data[1];
      this.getPageByElectricPendingApprovalPage();
    },

    // 我已审批页码跳转(电费)
    changeElectricApprovedPagination(data) {
      this.electricApprovedPageNum = data[0];
      this.electricApprovedPageSize = data[1];
      this.getPageByElectricApprovedPage();
    },

    // 我发起的页码跳转(水费)
    changeWaterSponsoredPagination(data) {
      this.waterSponsoredPageNum = data[0];
      this.waterSponsoredPageSize = data[1];
      this.getPageByWaterSponsorAccountCode();
    },

    // 待我审批页码跳转(水费)
    changeWaterPendingApprovalPagination(data) {
      this.waterPendingApprovalPageNum = data[0];
      this.waterPendingApprovalPageSize = data[1];
      this.getPageByWaterPendingApprovalPage();
    },

    // 我已审批页码跳转(水费)
    changeWaterApprovedPagination(data) {
      this.waterApprovedPageNum = data[0];
      this.waterApprovedPageSize = data[1];
      this.getPageByWaterApprovedPage();
    },

    // 我发起的页码跳转(账单)
    changeBillSponsoredPagination(data) {
      this.electricSponsoredPageNum = data[0];
      this.electricSponsoredPageSize = data[1];
      this.getPageByElectricSponsorAccountCode();
    },

    // 待我审批页码跳转(账单)
    changeBillPendingApprovalPagination(data) {
      this.electricPendingApprovalPageNum = data[0];
      this.electricPendingApprovalPageSize = data[1];
      this.getPageByElectricPendingApprovalPage();
    },

    // 我已审批页码跳转(账单)
    changeBillApprovedPagination(data) {
      this.electricApprovedPageNum = data[0];
      this.electricApprovedPageSize = data[1];
      this.getPageByElectricApprovedPage();
    },

    // 我发起的页码跳转(孵化)
    changeHatchSponsoredPagination(data) {
      this.hatchSponsoredPageNum = data[0];
      this.hatchSponsoredPageSize = data[1];
      this.getPageByHatchSponsorAccountCode();
    },

    // 待我审批页码跳转(孵化)
    changeHatchPendingApprovalPagination(data) {
      this.hatchPendingApprovalPageNum = data[0];
      this.hatchPendingApprovalPageSize = data[1];
      this.getPageByHatchPendingApprovalPage();
    },

    // 我已审批页码跳转(孵化)
    changeHatchApprovedPagination(data) {
      this.hatchApprovedPageNum = data[0];
      this.hatchApprovedPageSize = data[1];
      this.getPageByHatchApprovedPage();
    },

    // 我发起的
    getPageBySponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.sponsoredPageNum;
      reqData.pageSize = this.sponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getPageBySponsorAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              let length = v.contractApproveChainStatuses.length - 1;
              if (
                v.contractApproveChainStatuses[length].approveStatus === "0"
              ) {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (
                  v.contractApproveChainStatuses[length].approveResult === "1"
                ) {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === "2"
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === "3"
                ) {
                  v.workState = "审批加签";
                }
              }
              if (v.approveType === "4") {
                v.auditType = "新建合同";
              } else if (v.approveType === "5") {
                v.auditType = "续租合同";
              } else if (v.approveType === "6") {
                v.auditType = "退租合同";
              } else if (v.approveType === "15") {
                v.auditType = "作废合同";
              } else if (v.approveType === "17") {
                v.auditType = "换租合同";
              }
              v.handlePeople =
                v.contractApproveChainStatuses[length].approveAccountName;
            });
            this.sponsoredTotal = res.data.data.total;
            this.sponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取我发起的审批数据失败"));
    },

    // 待我审批
    getPendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.pendingApprovalPageNum;
      reqData.pageSize = this.pendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "0";
      this.$axios
        .post(api.getPageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.approveType === "4") {
                v.auditType = "新建合同";
              } else if (v.approveType === "5") {
                v.auditType = "续租合同";
              } else if (v.approveType === "6") {
                v.auditType = "退租合同";
              } else if (v.approveType === "15") {
                v.auditType = "作废合同";
              } else if (v.approveType === "17") {
                v.auditType = "换租合同";
              }
            });
            this.pendingApprovalTotal = res.data.data.total;
            this.pendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取待我审批数据失败"));
    },

    // 我已审批
    getApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.approvedPageNum;
      reqData.pageSize = this.approvedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "1";
      this.$axios
        .post(api.getPageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (
                v.contractApproveChainStatuses[length].approveStatus === "0"
              ) {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (
                  v.contractApproveChainStatuses[length].approveResult === "1"
                ) {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === "2"
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === "3"
                ) {
                  v.workState = "审批加签";
                }
              }
              if (v.approveType === "4") {
                v.auditType = "新建合同";
              } else if (v.approveType === "5") {
                v.auditType = "续租合同";
              } else if (v.approveType === "6") {
                v.auditType = "退租合同";
              } else if (v.approveType === "15") {
                v.auditType = "作废合同";
              } else if (v.approveType === "17") {
                v.auditType = "换租合同";
              }
            });
            this.approvedTotal = res.data.data.total;
            this.approvedTableData = data;
          }
        })
        .catch(errorHandler("获取我已审批数据失败"));
    },

    // 我发起的(电费)
    getPageByElectricSponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.electricSponsoredPageNum;
      reqData.pageSize = this.electricSponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getElectricApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.electricSponsoredTotal = res.data.data.total;
            this.electricSponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 待我审批(电费)
    getPageByElectricPendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.electricPendingApprovalPageNum;
      reqData.pageSize = this.electricPendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.status = "1";
      this.$axios
        .post(api.getElectricApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.electricPendingApprovalTotal = res.data.data.total;
            this.electricPendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 我已审批(电费)
    getPageByElectricApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.electricApprovedPageNum;
      reqData.pageSize = this.electricApprovedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.status = "2,3";
      this.$axios
        .post(api.getElectricApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.electricApprovedTotal = res.data.data.total;
            this.electricApprovedTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 电费审批通过
    electricApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.electricApproveData = data;
      this.approveDialog = true;
    },
    // 电费审批驳回
    electricUnApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.electricUnApproveData = data;
      this.approveRejectDialog = true;
    },

    // 我发起的(水费)
    getPageByWaterSponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.waterSponsoredPageNum;
      reqData.pageSize = this.waterSponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getWaterApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.waterSponsoredTotal = res.data.data.total;
            this.waterSponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 待我审批(水费)
    getPageByWaterPendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.waterPendingApprovalPageNum;
      reqData.pageSize = this.waterPendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.status = "1";
      this.$axios
        .post(api.getWaterApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.waterPendingApprovalTotal = res.data.data.total;
            this.waterPendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 我已审批(水费)
    getPageByWaterApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.waterApprovedPageNum;
      reqData.pageSize = this.waterApprovedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.status = "2,3";
      this.$axios
        .post(api.getWaterApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.waterApprovedTotal = res.data.data.total;
            this.waterApprovedTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 水费审批通过
    waterApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.waterApproveData = data;
      this.waterApproveDialog = true;
    },
    // 水费审批驳回
    waterUnApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.waterUnApproveData = data;
      this.waterApproveRejectDialog = true;
    },

    // 取消通过
    cancelApprove() {
      this.approveMemo = "";
      this.approveDialog = false;
    },

    // 确认通过
    passSubmit() {
      this.electricApproveData.memo = this.approveMemo;
      this.$axios
        .post(api.passElectricApprove, this.electricApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.approveMemo = "";
            this.approveDialog = false;
            nSuccess("审批已通过");
            this.getPageByElectricPendingApprovalPage();
          }
        })
        .catch(errorHandler("通过失败"));
    },

    // 取消驳回
    cancelReject() {
      this.rejectMemo = "";
      this.approveRejectDialog = false;
    },

    // 确认驳回
    unpassSubmit() {
      this.electricUnApproveData.memo = this.rejectMemo;
      this.$axios
        .post(api.unPassElectricApprove, this.electricUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.rejectMemo = "";
            this.approveRejectDialog = false;
            nSuccess("审批已驳回");
            this.getPageByElectricPendingApprovalPage();
          }
        })
        .catch(errorHandler("驳回失败"));
    },

    // 取消通过(水费)
    waterCancelApprove() {
      this.waterApproveMemo = "";
      this.waterApproveDialog = false;
    },

    // 确认通过(水费)
    waterPassSubmit() {
      this.waterApproveData.memo = this.waterApproveMemo;
      this.$axios
        .post(api.passWaterApprove, this.waterApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.waterApproveMemo = "";
            this.waterApproveDialog = false;
            nSuccess("审批已通过");
            this.getPageByWaterPendingApprovalPage();
          }
        })
        .catch(errorHandler("通过失败"));
    },

    // 取消驳回(水费)
    waterCancelReject() {
      this.waterRejectMemo = "";
      this.waterApproveRejectDialog = false;
    },

    // 确认驳回(水费)
    waterUnpassSubmit() {
      this.waterUnApproveData.memo = this.waterRejectMemo;
      this.$axios
        .post(api.unPassWaterApprove, this.waterUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.waterRejectMemo = "";
            this.waterApproveRejectDialog = false;
            nSuccess("审批已驳回");
            this.getPageByWaterPendingApprovalPage();
          }
        })
        .catch(errorHandler("驳回失败"));
    },

    // 我发起的(账单)
    getPageByBillSponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.electricSponsoredPageNum;
      reqData.pageSize = this.electricSponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getBillApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.billSponsoredTotal = res.data.data.total;
            this.billSponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 待我审批(账单)
    getPageByBillPendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.electricPendingApprovalPageNum;
      reqData.pageSize = this.electricPendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.status = "1";
      this.$axios
        .post(api.getBillApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.billPendingApprovalTotal = res.data.data.total;
            this.billPendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 我已审批(账单)
    getPageByBillApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.electricApprovedPageNum;
      reqData.pageSize = this.electricApprovedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.status = "2,3";
      this.$axios
        .post(api.getBillApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.billApprovedTotal = res.data.data.total;
            this.billApprovedTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 账单审批通过
    billApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.billApproveData = data;
      this.approveBillDialog = true;
    },
    // 账单审批驳回
    billUnApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.billUnApproveData = data;
      this.approveBillRejectDialog = true;
    },

    // 取消通过
    cancelBillApprove() {
      this.billMemo = "";
      this.approveBillDialog = false;
    },

    // 确认通过
    passBillSubmit() {
      this.billApproveData.memo = this.billMemo;
      this.$axios
        .post(api.passBillApprove, this.billApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.billMemo = "";
            this.approveBillDialog = false;
            nSuccess("审批已通过");
            this.getPageByBillPendingApprovalPage();
          }
        })
        .catch(errorHandler("通过失败"));
    },

    // 取消驳回
    cancelBillReject() {
      this.billMemo = "";
      this.approveBillRejectDialog = false;
    },

    // 确认驳回
    unpassBillSubmit() {
      this.billUnApproveData.memo = this.billMemo;
      this.$axios
        .post(api.unpassBillApprove, this.billUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.billMemo = "";
            this.approveBillRejectDialog = false;
            nSuccess("审批已驳回");
            this.getPageByBillPendingApprovalPage();
          }
        })
        .catch(errorHandler("驳回失败"));
    },

    // 获取投诉建议分页
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getSuggestionsPage, reqData)
        .then((res) => {
          let data = res.data.data.list;
          this.total = res.data.data.total;
          data.map((v) => {
            if (v.status === "0") {
              v.statusText = "未处理";
            } else if (v.status === "1") {
              v.statusText = "已处理";
            }
            v.createTime = v.createTime.slice(0, 19);
          });
          this.tableData = data;
        })
        .catch(errorHandler("获取信息失败"));
    },

    // 跳转修改投诉建议页面
    goToModifyPage(code) {
      this.$router.push({
        path: `/user_center/suggestions_details/${code}`,
      });
    },

    // 我发起的(孵化)
    getPageByHatchSponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.hatchSponsoredPageNum;
      reqData.pageSize = this.hatchSponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getHatchPageBySponsorAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              let length = v.contractApproveChainStatuses.length - 1;
              if (v.contractApproveChainStatuses[length].approveStatus === 0) {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (
                  v.contractApproveChainStatuses[length].approveResult === 1
                ) {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === 2
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === 3
                ) {
                  v.workState = "审批加签";
                }
              }
              if (v.approveType === 2) {
                v.auditType = "新建待审批";
              } else if (v.approveType === 3) {
                v.auditType = "作废待审批";
              }
              v.handlePeople =
                v.contractApproveChainStatuses[length].approveAccountName;
            });
            this.hatchSponsoredTotal = res.data.data.total;
            this.hatchSponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 待我审批(孵化)
    getPageByHatchPendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.hatchPendingApprovalPageNum;
      reqData.pageSize = this.hatchPendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "0";
      this.$axios
        .post(api.getHatchPageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.approveType === 2) {
                v.auditType = "新建待审批";
              } else if (v.approveType === 3) {
                v.auditType = "作废待审批";
              }
            });
            this.hatchPendingApprovalTotal = res.data.data.total;
            this.hatchPendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取待我审批数据失败"));
    },

    // 我已审批(孵化)
    getPageByHatchApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.hatchApprovedPageNum;
      reqData.pageSize = this.hatchApprovedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "1";
      this.$axios
        .post(api.getHatchPageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.contractApproveChainStatuses[length].approveStatus === 0) {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (
                  v.contractApproveChainStatuses[length].approveResult === 1
                ) {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === 2
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === 3
                ) {
                  v.workState = "审批加签";
                }
              }
              if (v.approveType === 2) {
                v.auditType = "新建待审批";
              } else if (v.approveType === 3) {
                v.auditType = "作废待审批";
              }
            });
            this.hatchApprovedTotal = res.data.data.total;
            this.hatchApprovedTableData = data;
          }
        })
        .catch(errorHandler("获取我已审批数据失败"));
    },

    // 跳转孵化详情页面
    toHatchDetailsPage(data) {
      sessionStorage.setItem("hatchWorkDetailData", JSON.stringify(data));
      sessionStorage.setItem("hatchWorkDetailActiveName", this.hatchActiveName);
      this.$router.push({
        name: "hatch-approval-detail",
      });
    },

    // 我发起的页码跳转(考勤)
    changeAttendanceSponsoredPagination(data) {
      this.attendanceSponsoredPageNum = data[0];
      this.attendanceSponsoredPageSize = data[1];
      this.getPageByAttendanceSponsorAccountCode();
    },

    // 待我审批页码跳转(考勤)
    changeAttendancePendingApprovalPagination(data) {
      this.attendancePendingApprovalPageNum = data[0];
      this.attendancePendingApprovalPageSize = data[1];
      this.getPageByAttendancePendingApprovalPage();
    },

    // 我已审批页码跳转(考勤)
    changeAttendanceApprovedPagination(data) {
      this.attendanceApprovedPageNum = data[0];
      this.attendanceApprovedPageSize = data[1];
      this.getPageByAttendanceApprovedPage();
    },

    // 我发起的(考勤)
    getPageByAttendanceSponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.attendanceSponsoredPageNum;
      reqData.pageSize = this.attendanceSponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getAttendanceApprovePageBySponsorAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              v.approveAccountName =
                v.eventApproveChinaStatuses[0].approveAccountName;
              if (v.eventApproveChinaStatuses[0].approveDate) {
                v.approveDate = v.eventApproveChinaStatuses[0].approveDate.slice(
                  0,
                  19
                );
              }
              if (v.eventApproveChinaStatuses[0].approveStatus === "0") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (v.eventApproveChinaStatuses[0].approveResult === "1") {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.eventApproveChinaStatuses[0].approveResult === "2"
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                }
              }
            });
            this.attendanceSponsoredTotal = res.data.data.total;
            this.attendanceSponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 待我审批(考勤)
    getPageByAttendancePendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.attendancePendingApprovalPageNum;
      reqData.pageSize = this.attendancePendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "0";
      this.$axios
        .post(api.getAttendanceApprovePageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              v.eventApproveChainStatusCode =
                v.eventApproveChinaStatuses[0].code;
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.eventApproveChinaStatuses[0].status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.eventApproveChinaStatuses[0].status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.eventApproveChinaStatuses[0].status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.attendancePendingApprovalTotal = res.data.data.total;
            this.attendancePendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 我已审批(考勤)
    getPageByAttendanceApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.attendanceApprovedPageNum;
      reqData.pageSize = this.attendanceApprovedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "1";
      this.$axios
        .post(api.getAttendanceApprovePageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              v.approveAccountName =
                v.eventApproveChinaStatuses[0].approveAccountName;
              if (v.eventApproveChinaStatuses[0].approveDate) {
                v.approveDate = v.eventApproveChinaStatuses[0].approveDate.slice(
                  0,
                  19
                );
              }
              if (v.eventApproveChinaStatuses[0].approveStatus === "0") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (v.eventApproveChinaStatuses[0].approveResult === "1") {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.eventApproveChinaStatuses[0].approveResult === "2"
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                }
              }
            });
            this.attendanceApprovedTotal = res.data.data.total;
            this.attendanceApprovedTableData = data;
            console.log(this.attendanceApprovedTableData);
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 考勤审批通过
    attendanceApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.attendanceApproveData = data;
      this.approveAttendanceDialog = true;
    },
    // 考勤审批驳回
    attendanceUnApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.attendanceUnApproveData = data;
      this.approveAttendanceRejectDialog = true;
    },

    // 取消通过
    cancelAttendanceApprove() {
      this.attendanceMemo = "";
      this.approveAttendanceDialog = false;
    },

    // 确认通过
    passAttendanceSubmit() {
      this.attendanceApproveData.memo = this.attendanceMemo;
      this.$axios
        .post(api.passSubmitAttendanceApprove, this.attendanceApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.attendanceMemo = "";
            this.approveAttendanceDialog = false;
            nSuccess("审批已通过");
            this.getPageByAttendancePendingApprovalPage();
          }
        })
        .catch(errorHandler("通过失败"));
    },

    // 取消驳回
    cancelAttendanceReject() {
      this.attendanceMemo = "";
      this.approveAttendanceRejectDialog = false;
    },

    // 确认驳回
    unpassAttendanceSubmit() {
      this.attendanceUnApproveData.memo = this.attendanceMemo;
      this.$axios
        .post(api.unPassSubmitAttendanceApprove, this.attendanceUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.attendanceMemo = "";
            this.approveAttendanceRejectDialog = false;
            nSuccess("审批已驳回");
            this.getPageByAttendancePendingApprovalPage();
          }
        })
        .catch(errorHandler("驳回失败"));
    },
  },
  watch: {
    activeName(val) {
      if (val === "sponsored") {
        this.sponsoredPageNum = 1;
        this.sponsoredPageSize = 10;
        this.getPageBySponsorAccountCode();
      } else if (val === "pendingApproval") {
        this.pendingApprovalPageNum = 1;
        this.pendingApprovalPageSize = 10;
        this.getPendingApprovalPage();
      } else if (val === "approved") {
        this.approvedPageNum = 1;
        this.approvedPageSize = 10;
        this.getApprovedPage();
      }
    },

    electricActiveName(val) {
      if (val === "electricSponsored") {
        this.electricSponsoredPageNum = 1;
        this.electricSponsoredPageSize = 10;
        this.getPageByElectricSponsorAccountCode();
      } else if (val === "electricPendingApproval") {
        this.electricPendingApprovalPageNum = 1;
        this.electricPendingApprovalPageSize = 10;
        this.getPageByElectricPendingApprovalPage();
      } else if (val === "electricApproved") {
        this.electricApprovedPageNum = 1;
        this.electricApprovedPageSize = 10;
        this.getPageByElectricApprovedPage();
      }
    },

    billActiveName(val) {
      if (val === "billSponsored") {
        this.billSponsoredPageNum = 1;
        this.billSponsoredPageSize = 10;
        this.getPageByBillSponsorAccountCode();
      } else if (val === "billPendingApproval") {
        this.billPendingApprovalPageNum = 1;
        this.billPendingApprovalPageSize = 10;
        this.getPageByBillPendingApprovalPage();
      } else if (val === "billApproved") {
        this.billApprovedPageNum = 1;
        this.billApprovedPageSize = 10;
        this.getPageByBillApprovedPage();
      }
    },

    waterActiveName(val) {
      if (val === "waterSponsored") {
        this.waterSponsoredPageNum = 1;
        this.waterSponsoredPageSize = 10;
        this.getPageByWaterSponsorAccountCode();
      } else if (val === "waterPendingApproval") {
        this.waterPendingApprovalPageNum = 1;
        this.waterPendingApprovalPageSize = 10;
        this.getPageByWaterPendingApprovalPage();
      } else if (val === "waterApproved") {
        this.waterApprovedPageNum = 1;
        this.waterApprovedPageSize = 10;
        this.getPageByWaterApprovedPage();
      }
    },

    hatchActiveName(val) {
      if (val === "hatchSponsored") {
        this.hatchSponsoredPageNum = 1;
        this.hatchSponsoredPageSize = 10;
        this.getPageByHatchSponsorAccountCode();
      } else if (val === "hatchPendingApproval") {
        this.hatchPendingApprovalPageNum = 1;
        this.hatchPendingApprovalPageSize = 10;
        this.getPageByHatchPendingApprovalPage();
      } else if (val === "hatchApproved") {
        this.hatchApprovedPageNum = 1;
        this.hatchApprovedPageSize = 10;
        this.getPageByHatchApprovedPage();
      }
    },

    attendanceActiveName(val) {
      if (val === "attendanceSponsored") {
        this.attendanceSponsoredPageNum = 1;
        this.attendanceSponsoredPageSize = 10;
        this.getPageByAttendanceSponsorAccountCode();
      } else if (val === "attendancePendingApproval") {
        this.attendancePendingApprovalPageNum = 1;
        this.attendancePendingApprovalPageSize = 10;
        this.getPageByAttendancePendingApprovalPage();
      } else if (val === "attendanceApproved") {
        this.attendanceApprovedPageNum = 1;
        this.attendanceApprovedPageSize = 10;
        this.getPageByAttendanceApprovedPage();
      }
    },
  },
};
</script>

<style lang="less">
.workbench-approval {
  /deep/ .el-collapse-item__header {
    height: 60px;
    line-height: 60px;
  }
  .item {
    font-size: 16px;
    line-height: 28px;
    margin-right: 29px;
    .el-badge__content.is-fixed {
      top: 2px;
      right: 5px;
    }
    i {
      width: 40px;
      font-size: 18px;
      color: #00a0e6;
      margin-right: 5px;
    }
  }
  .breadcrumb-box {
    border-bottom: 0 !important;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      /*padding-left: 20px!important;*/
      padding: 0 20px 0 0;
      margin-left: 0;
    }
    #tab-pendingApproval {
      /*margin: 0 20px 0 0;*/
    }
    .is-top:last-child {
      /*padding-left: 0;*/
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-main {
    height: 96%;
    /*padding: 10px 10px 0 10px;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    h4 {
      border-left: 3px solid #00a0e6;
      padding-left: 5px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      text-align: left;
    }
    .approval-main-top {
      height: 45%;
      .all-table-class .el-table td {
        padding: 3px 0;
      }
    }
    .approval-main-bottom {
      height: 45%;
      .all-table-class .el-table td {
        padding: 8px 0;
      }
    }
    .el-tabs__content {
      padding-bottom: 20px;
      height: 100%;
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Workbench/WorkbenchApproval.vue